import { useState, useEffect } from "react";

export const isMobile = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
    }, [windowWidth]);

    return windowWidth <= 768 ? true:false
}
